export const fakePlatforms: Array<{code: string; title: string}> = [
  {code: 'fastback_trade', title: 'Fastback Trade'},
  {code: 'fastback_inter_dealer', title: 'Fastback Inter Dealer'},
  {code: 'community', title: 'Community'},
];
